module.exports = __webpack_public_path__ + "img/volume-up-fill.04799ee2.svg";